import Vue from 'vue';

export default new Vue({
  data: {},
  methods: {
    /**
     * @description
     * Load list of loyalty cards
     */
    async getLoyaltyCards(rawParams) {
      const params = {
        qLastName: rawParams.qLastName || undefined,
        qFirstName: rawParams.qFirstName || undefined,
        qPesel: rawParams.qPesel || undefined,
        qCardNumber: rawParams.qCardNumber || undefined,
        qCardType: rawParams.qCardType || undefined,
        sortOrder: rawParams.sortOrder || undefined,
        qMigration: rawParams.qMigration || undefined,
        qComment: rawParams.qComment || undefined,
        qStatus: rawParams.qStatus || 'active',
        orderBy: rawParams.orderBy || undefined,
        offset: rawParams.offset || 0,
        pageSize: rawParams.pageSize || 10,
      };
      return await this.$http.get('/api/loyalty-cards', { params })
        .then(response => response);
    },
    /**
     * @description
     * Get loylaty cards item details
     */
    async getItem(loyaltyId) {
      return await this.$http.get(`/api/loyalty-cards/${loyaltyId}`)
        .then(response => response);
    },
    async updateCardActiveStatus(cardData) {
      return await this.$http.post(`/api/loyalty-cards/activation/${cardData.loyaltyId}`, { isActive: !cardData.isActive });
    },
    /**
     * @description
     * Add new loyalty card
     */
    async addLoylatyCard(data) {
      return await this.$http.post('/api/loyalty-cards/new', data)
        .then(response => response);
    },
    /**
     * @description
     * Assign client to loyalty card
     */
    async assignClient(loyaltyId, clientId) {
      return await this.$http.put(`/api/loyalty-cards/${loyaltyId}/assign-client`, { clientId })
        .then(response => response);
    },

  }
});